const isDev = process.env.NODE_ENV === 'development';
const isProd = process.env.NODE_ENV === 'production';
const isStaging = process.env.REACT_APP_STAGING === 'true';

const DEV_COGNITO = {
  REGION: 'us-east-2',
  USER_POOL_ID: 'us-east-2_PBuXWv1cY',
  USER_POOL_WEB_CLIENT_ID: '5arh9i5i2vbno3um9tm5o8b51d',
  IDENTITY_POOL_ID: 'us-east-2:fc266e57-b2a4-4fc9-862c-a55041e0032b',
};

const PROD_COGNITO = {
  REGION: 'us-east-2',
  USER_POOL_ID: 'us-east-2_wbqkCbVnj',
  USER_POOL_WEB_CLIENT_ID: '2oqn90hg851kss61gtu4vodqa8',
  IDENTITY_POOL_ID: 'us-east-2:874331b7-299e-4e5d-9a28-669e1c65210d',
};

const prodConfig = {
  MIXPANEL: 'c5bad8f59c99ba6b634f4b3d25c032c4',
  STRIPE_API_KEY: "pk_live_ew59jWBJn3oq0oWjiszc5MsU00svTwYTaw",
  PAYPAL_CLIENT_ID: "AUDSxRMb1SXzyWbwi3lBSe-7t95SscBv6BQcF4cJr0_eTK8mDq5gxy62VGzBLPR2EuAjVSuaN-a09ZXA",
  PRIMAL_APP_TOKEN: "",
  PRIMAL_APP_API: "https://apimarket.primaltcg.com",
  TMP_API: "https://apimarket.primaltcg.com/",
  MIXPANEL_KEY: "6355b9138ef99a42321be6306756111e",
  IMAGE_COMPRESSION : 0.6, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  MAX_IMAGE_WIDTH : 600, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  MIN_IMAGE_WIDTH : 400, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  DOMAIN: "https://apimarket.primaltcg.com",
  CARD_IMAGE_BASE: "https://apimarket.primaltcg.com/",
  SELLER_MARKET_RATE : 0.90, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  MINIMAL_PROFIT: 1.00, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  TRACKING_UPGRADE_FEE: 5.50, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  FREE_SHIPPING_THRESHOLD: 10, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  TRACKING_REQUIRED_THRESHOLD: 50, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  FLAT_SHIPPING_FEE: 1.00, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  TRANSACTION_FEE: 0.50, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  SHARE_MIN_PRICE: 10, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  SENTRY_DSN: 'https://o4510949568675840.ingest.us.sentry.io/4510949573525504',
  COGNITO: PROD_COGNITO,
}

const devConfig = {
  MIXPANEL: '6355b9138ef99a42321be6306756111e',
  STRIPE_API_KEY: "pk_test_AyUPzq9ZIzn2AYu9jB3pk2hd00otmPIzlq",
  PAYPAL_CLIENT_ID: "AaDH_cKPZoFXA4lY7Gg8Pf93fpeqM_IJAMjHmprxI8L9hnMGLEGj501XcF8dtS8UiYqlueoB1DvVM93e",
  PRIMAL_APP_TOKEN: "",
  PRIMAL_APP_API: "http://localhost:8080",
  TMP_API: "http://localhost:8080/",
  MIXPANEL_KEY: "6355b9138ef99a42321be6306756111e",
  IMAGE_COMPRESSION : 0.6, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  MAX_IMAGE_WIDTH : 600, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  MIN_IMAGE_WIDTH : 400, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  DOMAIN: "http://localhost:8080",
  CARD_IMAGE_BASE: "http://localhost:8080/",
  SELLER_MARKET_RATE : 0.90, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  MINIMAL_PROFIT: 1.00, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  TRACKING_UPGRADE_FEE: 5.50, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  FREE_SHIPPING_THRESHOLD: 10, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  TRACKING_REQUIRED_THRESHOLD: 50, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  FLAT_SHIPPING_FEE: 1.00, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  TRANSACTION_FEE: 0.50, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  SHARE_MIN_PRICE: 10, // See src/config/constants.js — duplicated here for backward compat, remove in follow-up
  SENTRY_DSN: 'https://o4510949568675840.ingest.us.sentry.io/4510949573525504',
  COGNITO: DEV_COGNITO,
}
// Staging: staging domains + test payment keys
const stagingConfig = {
  ...prodConfig,
  COGNITO: DEV_COGNITO,
  STRIPE_API_KEY: devConfig.STRIPE_API_KEY,
  PAYPAL_CLIENT_ID: devConfig.PAYPAL_CLIENT_ID,
  PRIMAL_APP_API: "https://staging-apimarket.primaltcg.com",
  TMP_API: "https://staging-apimarket.primaltcg.com/",
  DOMAIN: "https://staging-apimarket.primaltcg.com",
  CARD_IMAGE_BASE: "https://staging-apimarket.primaltcg.com/",
};

let Config;
if (isProd) {
  Config = isStaging ? stagingConfig : prodConfig;
  console.log(isStaging ? 'Running Staging Config' : 'Running Production Config');
}
if (isDev) {
  console.log('Running Development Config');
  Config = devConfig;
}
export default Config;
